import React, { ChangeEvent } from 'react'
import { TextField } from '@mui/material'

export interface StyledTextFieldProps {
  ref?: React.RefObject<any>
  disabled?: boolean
  error?: boolean
  value: string | undefined
  onChange: (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void
  placeholder?: string
  helperText?: string
  id?: string
  type?: string
  ariaLabel?: string
  'aria-label'?: string
  disableUnderline?: boolean
  inputMode?: 'text' | 'decimal' | 'numeric' | 'tel' | 'search' | 'email' | 'url'
  inputRef?: React.Ref<HTMLInputElement>
  InputProps?: {
    classes?: Record<string, string>
    disableUnderline?: boolean
    [key: string]: any
  }
  classes?: Record<string, string>
  onKeyDown?: (e: React.KeyboardEvent<any>) => void
  onFocus?: (e: React.FocusEvent<any>) => void
  onBlur?: (e: React.FocusEvent<any>) => void
  sx?: Record<string, any>
}

export const StyledTextField: React.FC<StyledTextFieldProps> = ({
  ref,
  disabled = false,
  error = false,
  value,
  onChange,
  placeholder,
  helperText,
  id,
  type = 'text',
  ariaLabel,
  'aria-label': ariaLabelProp,
  disableUnderline = false,
  inputMode,
  inputRef,
  InputProps,
  classes,
  onKeyDown,
  onFocus,
  onBlur,
  sx
}) => {
  const finalAriaLabel = ariaLabelProp || ariaLabel || id

  return (
    <TextField
      ref={ref}
      inputRef={inputRef}
      inputMode={inputMode}
      disabled={disabled}
      error={error}
      inputProps={{
        'aria-label': finalAriaLabel
      }}
      InputProps={{
        disableUnderline: InputProps?.disableUnderline ?? disableUnderline,
        classes: InputProps?.classes,
        ...InputProps
      }}
      type={type}
      id={id}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onBlur={onBlur}
      placeholder={placeholder}
      helperText={helperText}
      classes={classes}
      sx={sx}
      variant="standard"
    />
  )
}
